import styled from '@emotion/styled';
import { getColor } from '../../../common/UICommon';
import { TabletWidth } from '../../../../global.style';

export const BREAKPOINTS = {
  DESKTOP_MAX: 999999999,
  TABLET_WIDTH_START: 900,
  MOBILE1_WIDTH_START: 700,
  MOBILE2_WIDTH_START: 600,
  MOBILE3_WIDTH_START: 500,
};

export const StoriesSectionWrapper = styled.div<{ withBottomBorder: boolean }>`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1120px;
  margin: auto;
  position: relative;
  z-index: 1;
  ${({ withBottomBorder }) => withBottomBorder && `border-bottom: 1px solid ${getColor('GRAY_40')};`}
  ${({ withBottomBorder }) => withBottomBorder && `padding-bottom: 80px;`}

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    padding-bottom: 32px;
    border-bottom: 1px solid ${getColor('GRAY_30')};
  }
`;

export const StoriesSectionTitle = styled.p`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
  text-align: center;
  margin-top: 80px;
  color: ${getColor('GRAY_70')};

  @media (max-width: ${TabletWidth}px) {
    margin-top: 50px;
    font-size: 24px;
    line-height: 36px;
  }
`;
export const StoriesSectionSubtitle = styled.p`
  font-family: Poppins;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin-top: 6px;
  color: ${getColor('GRAY_70')};

  @media (max-width: ${TabletWidth}px) {
    font-size: 16px;
    margin-top: 4px;
  }
`;

export const StoriesSectionStories = styled.div<{ withTitles: boolean }>`
  ${({ withTitles }) => withTitles && 'margin-top: 66px;'}
  width: 100%;
  max-width: 950px;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 32px;
    margin-left: 12px;
  }
`;

export const StoriesSectionStoryWrapper = styled.div`
  height: 380px;
  margin-left: 24px;
  margin-right: 24px;

  @media (max-width: ${TabletWidth}px) {
    margin-left: 12px;
    margin-right: 12px;
    min-height: 380px;
    height: 100%;
  }
`;

export const StoriesSectionStoryContent = styled.div`
  background-color: ${getColor('BEIGE_5')};
  border-radius: 32px;
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StoriesSectionStoryRating = styled.div`
  text-align: left;
  margin-bottom: 16px;
  display: flex;
  gap: 2px;
`;

export const StoriesSectionStoryStar = styled.img``;

export const StoriesSectionStoryText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: ${getColor('GRAY_70')};
  margin-bottom: 24px;
  flex-grow: 1;
`;

export const StoriesSectionStoryMember = styled.div`
  display: flex;
`;

export const StoriesSectionStoryMemberAvatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 100px;
  margin-right: 12px;
`;

export const StoriesSectionStoryMemberRight = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;
export const StoriesSectionStoryMemberName = styled.label`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: ${getColor('GRAY_95')};
  margin-bottom: 4px;
`;

export const StoriesSectionStoryMemberLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StoriesSectionStoryMemberLabel = styled.label`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: ${getColor('GRAY_50')};
`;

export const StoriesSectionStoryMemberIcon = styled.img``;
